import { Injectable } from '@angular/core';

import {
  Client,
  ClientsService,
  EntityQuestion,
  HiddenQuestion,
  QuestionBase,
  QuestionGroup,
  TextboxQuestion
} from '../core';

import { Document } from '.';

@Injectable()
export class DocumentsQuestionsService {
  constructor(public clients: ClientsService) {}

  getQuestions(document: any, clientId: string) {
    if (!clientId) {
      throw new Error('No clientId provided');
    }

    const questions: QuestionBase<any>[] = [
      new TextboxQuestion({
        key: 'name',
        label: 'nouns.name',
        value: document && document.name ? document.name : null,
        validators: { required: true },
        order: 1
      }),
      new HiddenQuestion({
        key: 'clientId',
        value: clientId,
        validators: { required: true },
        order: 3
      })
    ];

    if (!document || !document.isInternalUrl) {
      questions.push(
        new TextboxQuestion({
          key: 'url',
          label: 'nouns.url',
          value: document && document.url ? document.url : null,
          validators: { required: true, videoMediaUrl: true },
          order: 2
        })
      );
    }
    return questions.sort((a, b) => a.order - b.order);
  }

  getSelectClientQuestion(clientId: string) {
    const questions: QuestionBase<any>[] = [];
    if (clientId) {
      questions.push(
        new HiddenQuestion({
          key: 'clientId',
          value: clientId,
          validators: { required: true },
          order: 1
        })
      );
    } else {
      questions.push(
        new EntityQuestion({
          key: 'clientId',
          label: 'nouns.client',
          class: 'col s12',
          value: clientId ? clientId : null,
          entity: clientId,
          validators: { required: true },
          dataProvider: this.clients,
          disabled: false,
          order: 1
        })
      );
    }

    return questions.sort((a, b) => a.order - b.order);
  }
}
